// Entry point for the build script in your package.json

function importAll(r) {
  r.keys().forEach(r);
}

importAll(require.context('../assets/javascripts/', true, /\.js$/));
